import { CouponsConfig } from '@shared/models';

import {
  BARCODE_FORMAT,
  CouponOfferType,
  ProductCheckTabType,
  ScanCheckMode,
  Variants,
} from '../utils';

export const DRACO_CONFIG: CouponsConfig = {
  currency: 'EUR',
  appTitle: 'Intermarche',
  appIcon: 'assets/images/draco/favicon.ico',
  cssVariables: {
    'font-family': 'INTERMARCHE',
    'body-color': '#000000',
    'body-background-color': '#F0F2F6',
    // Used by the product-check modal (tab bar, loaders, dialog title), whose
    // tab bar renders now that the modal has two tabs.
    'challenge-primary-color': '#1D1D1D',
  },
  og: {
    title: 'Discover the best coupons and earn rewards with our app!',
    description:
      'Unlock amazing savings and exclusive offers with our coupon app. Browse a wide selection of coupons, load your favorites, and enjoy fantastic discounts at your favorite stores. Start saving today!',
  },
  pages: {
    availablePages: ['coupons', 'help'],
    sorry: {
      background: '#FFFFFF',
      content: [
        '<div style="text-align: center;"><img src="assets/images/draco/sorry-illustration.webp" style="max-width: 150px;" alt=""></div>',
        '<h1 style="margin: 1rem 0 0; font-size: 1.8rem; line-height: 1.2; font-family: var(--font-family); font-weight: 700; color: #1D1D1D;">Vos offres perso ne sont pas disponibles</h1>',
        '<p style="margin: 1rem auto 0; max-width: 480px; font-size: 1rem; line-height: 1.5; font-family: var(--font-family); color: #1D1D1D;">Vérifiez vos préférences dans votre compte client.<br/><br/>Pour accéder au dispositif  “Vos offres perso”, l’option « Je ne souhaite pas recevoir sur mon compte en ligne des promotions personnalisées en fonction de mes habitudes d’achats » ne doit pas être cochée.<br/><br/>Et Rendez-vous la semaine prochaine !</p>',
      ],
    },
    coupons: {
      meta: {
        title: 'Vos offres perso',
        description: 'Promos personnalisées juste pour vous',
        keywords:
          'coupons, promos exclusives, offres personnalisées, économies',
      },
      variant: Variants.VARIANT_1,
      background: '#F0F2F6',
      brandHeader: {
        background: '#FFFFFF',
        boxShadow:
          '0px 2px 2px rgba(29, 29, 29, 0.06), 0px 3px 2px rgba(29, 29, 29, 0.05)',
        logo: {
          href: 'https://www.intermarche.com',
          imageUrl: 'assets/images/draco/header-logo.svg',
          ariaLabel: 'Intermarché — accéder au site (nouvelle fenêtre)',
        },
      },
      top: {
        background: '#FFFFFF',
        boxShadow: '#9CA3AD33 0px 4px 8px',
        title: {
          color: '#1D1D1D',
          label: 'Vos offres perso',
          fontFamily: 'var(--font-family)',
        },
        info: {
          color: '#1D1D1D',
          background: '#FFFFFF',
          label: 'Comment ça marche ?',
          border: '1px solid #1D1D1D',
          fontFamily: 'var(--font-family)',
          icon: 'assets/images/draco/how-to-play-icon.svg',
        },
        tabs: {
          config: {
            fontFamily: 'var(--font-family)',
            border: {
              active: '2px solid black',
              default: '2px solid #E2E6EE',
            },
            background: {
              default: 'white',
              active: 'black',
            },
            color: {
              default: 'black',
              active: '#FFFFFF',
            },
          },
          items: [
            {
              label:
                'Activées <span style="letter-spacing: 1.75px;margin-left: 5px;">({variable})</span>',
            },
            {
              label:
                'À activer <span style="letter-spacing: 1.75px; margin-left: 5px;">({variable})</span>',
            },
            {
              label:
                'Utilisées <span style="letter-spacing: 1.75px; margin-left: 5px;">({variable})</span>',
            },
          ],
        },
      },
      header: {
        alternativeText: 'Vos Offres Personnalisées',
        imageUrl: 'assets/images/draco/banner.webp',
      },
      wallet: {
        background: 'white',
        dividerColor: '#C5C5C5',
        iconUrl: 'assets/images/draco/wallet-icon.svg',
        week: {
          amount: {
            color: '#145C00',
            label: '{variable} cagnottés',
            fontFamily: 'var(--font-family)',
          },
          period: {
            color: '#737C8C',
            label: 'cette semaine',
            fontFamily: 'var(--font-family)',
          },
        },
        year: {
          amount: {
            color: '#1D1D1D',
            label: '{variable} cagnottés',
            fontFamily: 'var(--font-family)',
          },
          period: {
            color: '#737C8C',
            label: 'cette année',
            fontFamily: 'var(--font-family)',
          },
        },
        detailsLabel: 'Voir le détail de ma cagnotte',
        button: {
          iconUrl: 'assets/images/draco/wallet-btn.svg',
        },
      },
      legalMention: {
        color: '#1D1D1D',
        fontFamily: 'var(--font-family)',
        label:
          'POUR VOTRE SANTÉ, ÉVITEZ DE MANGER TROP GRAS, TROP SUCRÉ, TROP SALÉ.',
      },
    },
    help: {
      meta: {
        title: 'Comment ça marche ? - Promos exclusives',
        description:
          'Découvrez le fonctionnement des Promos exclusives et les réponses aux questions fréquentes.',
        keywords:
          'aide, comment ça marche, questions fréquentes, promos exclusives',
      },
      background: '#FFFFFF',
      backLink: {
        color: '#1D1D1D',
        label: 'Revenir aux offres perso',
        ariaLabel: 'Revenir aux offres perso',
        fontFamily: 'var(--font-family)',
        iconUrl: 'assets/images/draco/arrow-back.svg',
      },
      title: {
        color: '#1D1D1D',
        label: 'Comment ça marche ?',
        fontFamily: 'var(--font-family)',
      },
      howToPlay: {
        border: '1px solid #E2E6EE',
        borderRadius: '16px',
        background: '#FFFFFF',
        illustration: {
          pentagonUrl: 'assets/images/draco/how-to-play-pentagon.svg',
          illustrationUrl: 'assets/images/draco/how-to-play-voucher.webp',
          illustrationAlt: '',
        },
        label: {
          color: '#1D1D1D',
          fontFamily: 'var(--font-family)',
          label: 'Vos offres perso',
        },
        body: {
          color: '#1D1D1D',
          fontFamily: 'var(--font-family)',
          label:
            'Chaque semaine, découvrez des offres personnalisées selon vos habitudes d’achat. Activez vos offres puis présentez votre carte de fidélité lors de vos achats en ligne ou en magasin. Bénéficiez de votre avantage carte sous 5 jours.',
        },
      },
      faq: {
        title: {
          color: '#1D1D1D',
          label: 'Foire aux questions (FAQ) : Vos Offres Perso',
          fontFamily: 'var(--font-family)',
        },
        subtitle: {
          color: '#4A5160',
          label:
            'Découvrez comment fonctionnent « Vos offres perso » et comment en profiter au mieux lors de vos prochains achats.',
          fontFamily: 'var(--font-family)',
        },
        accordion: {
          dividerColor: '#E2E6EE',
          iconMore: 'assets/images/draco/expand-more.svg',
          iconLess: 'assets/images/draco/expand-less.svg',
          styles: {
            title: {
              color: '#33333F',
              fontSize: '16px',
              lineHeight: '22px',
              fontFamily: 'var(--font-family)',
            },
            description: {
              color: '#4A5160',
              fontSize: '15px',
              lineHeight: '22px',
              fontFamily: 'var(--font-family)',
            },
          },
        },
        questions: [
          {
            title: '1. Qu’est-ce que mes « Offres perso » ?',
            content:
              'Il s’agit d’un programme d’offres générées spécialement pour vous. Contrairement aux prospectus classiques valables pour tout le monde, ces offres sont créées sur mesure en fonction de vos habitudes de consommation et de vos produits préférés. Elles peuvent néanmoins ne pas toujours correspondre à vos envies ou à vos besoins du moment. Vos prochaines offres continueront d’évoluer en fonction de vos achats.<br/><br/>Les données collectées dans le cadre de « Vos offres perso » sont traitées conformément à la Politique de protection des données à caractère personnel de la carte de fidélité Intermarché, que vous pouvez consulter à tout moment sur notre site internet.<br/><br/>Si vous ne souhaitez plus recevoir sur votre compte en ligne des promotions personnalisées en fonction de vos habitudes d’achat, cochez l’option « Je ne souhaite pas recevoir sur mon compte en ligne des promotions personnalisées en fonction de mes habitudes d’achats » (RDV dans Compte &gt; Mes informations &gt; Préférences &gt; Gestion de mes préférences tout en bas de la page).',
          },
          {
            title: '2. Comment ces offres sont-elles choisies pour moi ?',
            content:
              'Notre système analyse l’historique de vos achats passés afin de comprendre ce que vous aimez. Il sélectionne ou crée ensuite les meilleures offres possibles sur les catégories de produits, les marques ou les rayons que vous achetez le plus régulièrement.',
          },
          {
            title: '3. Comment profiter de mes « offres perso » ?',
            content:
              'Pour en profiter : consultez vos offres sur l’application mobile ou votre espace client, puis activez celles qui vous intéressent avant de réaliser vos achats. Lors de votre passage en caisse ou de votre commande sur le Drive, utilisez la carte de fidélité associée à votre compte. Si les conditions de l’offre sont remplies, votre avantage sera automatiquement reversé sur votre compte de fidélité dans un délai de 5 jours maximum suivant votre achat.<br/><br/>Certaines offres disposent d’un nombre limité d’activations par semaine. Une fois ce nombre atteint, l’offre apparaît grisée avec la mention « Victime de son succès » et ne peut plus être activée.',
          },
          {
            title:
              '4. À quelle fréquence mes promotions sont-elles renouvelées et combien d’offres vais-je recevoir ?',
            content:
              'Vos promotions personnalisées sont renouvelées chaque semaine. Un nouveau lot de 8 offres exclusives et adaptées à vos besoins est mis à votre disposition tous les lundis. Ponctuellement, une offre additionnelle pourra vous être proposée.',
          },
          {
            title: '5. Où puis-je retrouver mes « Offres perso » ?',
            content:
              'Vous pouvez consulter vos offres à tout moment : directement sur l’application mobile, sur notre site internet (espace Drive et client), ou via les communications que vous recevez.',
          },
          {
            title:
              '6. Est-ce que mes promotions s’appliquent aussi bien en magasin qu’en Drive ?',
            content:
              'Oui, vos offres sont utilisables en magasin et en Drive. Vous pouvez les utiliser lors de votre passage en caisse dans votre magasin habituel ou lors de la validation de votre commande en ligne sur le Drive.<br/>Ponctuellement, certaines offres peuvent être utilisables uniquement en Drive.',
          },
          {
            title:
              '7. Tous les produits du magasin peuvent-ils faire l’objet d’une offre personnalisée ?',
            content:
              'Une grande majorité de vos produits du quotidien peuvent être concernés. Cependant, certaines catégories de produits sont strictement exclues de ce dispositif pour des raisons réglementaires et techniques. Les exclusions des offres sont consultables dans les mentions de votre offre, disponibles en cliquant sur le bouton d’information en haut à droite de chaque offre sur l’application et notre site internet.',
          },
          {
            title:
              '8. Pourquoi mon avantage carte n’apparaît-il pas immédiatement sur mon ticket de caisse ?',
            content:
              '<b>Attention : le traitement de vos avantages personnalisés se fait de manière différée.</b> Vos cagnottages sont calculés après la validation définitive de vos achats en caisse ou sur le Drive. Ils seront visibles et disponibles sur votre compte de fidélité dans un délai de 5 jours maximum suivant votre achat.',
          },
          {
            title:
              '9. Que se passe-t-il si je retourne un produit acheté avec une promotion personnalisée ?',
            content:
              'En cas de retour ou de remboursement d’un article en magasin, les avantages ou les points de fidélité qui vous avaient été attribués pour cet achat spécifique seront réajustés et déduits de votre solde.',
          },
          {
            title:
              '10. Puis-je partager mes promotions personnalisées avec un proche ?',
            content:
              'Non, ces offres sont strictement personnelles et directement liées à votre compte client et votre carte de fidélité.',
          },
          {
            title:
              '11. Puis-je utiliser plusieurs offres personnalisées lors d’un même achat ?',
            content:
              'Il est possible de profiter de plusieurs offres personnalisées lors d’un même achat, à condition de les avoir activées et de respecter les conditions indiquées pour chacune d’elles.',
          },
          {
            title:
              '12. Mes offres sont-elles cumulables avec les autres promotions ?',
            content:
              'Vos offres perso ne peuvent pas se cumuler avec d’autres offres présentes en prospectus ou issues du programme de fidélité.',
          },
          {
            title:
              '13. Dans quel magasin puis-je profiter de mes offres personnalisées ?',
            content:
              'Vous pouvez profiter de vos offres personnalisées dans tous les magasins Intermarché ainsi que sur les Drives Intermarché, pendant toute leur période de validité.',
          },
          {
            title: '14. Que faire si mon offre ne s’est pas déclenchée ?',
            content:
              'Vérifiez que votre offre a bien été activée au plus tard le jour de votre achat, qu’elle était toujours valable et que toutes ses conditions ont été respectées.<br/>Si après le délai de 5 jours suivant votre achat, votre avantage n’apparaît toujours pas, vous pouvez contacter notre service client en vous munissant de votre ticket de caisse ou de votre numéro de commande.<br/><br/>Pour rappel, vous pouvez cumuler sur votre carte de fidélité des avantages équivalents à un montant maximum total de quatre cents (400) euros par mois civil, toutes opérations proposant de cagnotter des avantages carte sur la carte de fidélité confondues.',
          },
          {
            title: '15. Comment suivre le cumul de mes avantages ?',
            content:
              'Vous pouvez à tout moment consulter le détail du cumul de vos avantages directement sur notre site intermarche.com ou sur l’app, en vous connectant à votre compte et en cliquant sur l’onglet « Vos offres perso ». Pour rappel, vos avantages sont crédités sur votre compte de fidélité dans un délai maximum de 5 jours suivant votre achat.',
          },
        ],
      },
      terms: {
        color: '#4A5160',
        fontFamily: 'var(--font-family)',
        title: {
          color: '#1D1D1D',
          label: 'Conditions générales d’utilisation',
          fontFamily: 'var(--font-family)',
        },
        content: [
          '<h3>1. Accès à « Vos offres perso »</h3>',
          '<p>« Vos offres perso » sont des avantages réservés aux clients titulaires d’une Carte de Fidélité Intermarché et répondant aux conditions d’éligibilité définies pour le dispositif.</p>',
          '<p>Pour consulter et utiliser « Vos offres perso », le Client doit associer sa Carte de Fidélité à son compte client sur les Supports Digitaux.</p>',
          '<p>Si le Client dispose déjà d’un compte client sur les Supports Digitaux, il lui suffit d’y renseigner le numéro de sa Carte de Fidélité selon les modalités indiquées sur le Support Digital concerné.</p>',
          '<p>Lorsque la création d’un compte client est nécessaire, les informations obligatoires à renseigner sont signalées par un astérisque. Elles sont nécessaires à la création du compte et à l’accès au service concerné.</p>',
          '<p>Les informations facultatives éventuellement demandées permettent, lorsque le Client a accepté leur utilisation à cette fin, de mieux connaître ses préférences et de lui proposer des offres et avantages susceptibles de correspondre à ses centres d’intérêt.</p>',
          '<p>Tout formulaire incomplet ou comportant des informations erronées peut empêcher la création ou la validation du compte. Lorsque la création d’un compte est effectuée, un courrier électronique de confirmation est adressé au Client à l’adresse renseignée lors de son inscription.</p>',

          '<h3>2. Fonctionnement de « Vos offres perso »</h3>',
          '<h4>2.1. Principe</h4>',
          '<p>« Vos offres perso » sont des avantages proposés aux Clients dans le cadre du programme de fidélité Intermarché. Elles peuvent porter notamment sur certaines catégories de produits, certaines marques ou certains rayons et sont susceptibles d’être personnalisées en fonction des achats et des habitudes d’achat du Client, dans les conditions prévues par la politique de protection des données personnelles applicable au programme de fidélité.</p>',
          '<p>Les Offres perso proposées peuvent donc varier d’un Client à l’autre. Tous les Clients titulaires d’une Carte de Fidélité ne bénéficient donc pas nécessairement des mêmes Offres perso.</p>',
          '<p>Vous pouvez exercer votre droit d’opposition en remplissant <a href="https://www.intermarche.com/aide-et-contact/mes-donnees-personnelles/contact-par-email?theme=Mes+donn%C3%A9es+personnelles&formType=DEFAULT&phoneGuide=3&subjectList=Mes+donn%C3%A9es+personnelles" target="_blank" rel="noopener noreferrer">ce formulaire</a>. Si vous exercez votre droit d’opposition, il ne pourra plus vous être proposé d’Offres perso en fonction de vos historiques d’achat.</p>',
          '<h4>2.2. Consultation de « Vos offres perso »</h4>',
          '<p>« Vos offres perso » peuvent être consultées, selon les modalités applicables au dispositif :</p>',
          '<ul><li>Sur l’application mobile Intermarché ;</li><li>Sur le site Internet Intermarché, notamment dans l’espace Client et/ou l’espace Drive ;</li><li>Dans les communications adressées au Client, lorsque celui-ci est éligible et sous réserve de ses choix en matière de communications commerciales et de personnalisation.</li></ul>',
          '<h4>2.3. Attribution de l’avantage</h4>',
          '<p>Lorsque le Client remplit les conditions prévues par une Offre perso, l’avantage associé à cette offre est reversé sur son compte fidélité dans un délai maximal de cinq (5) jours à compter de l’achat des produits concernés.</p>',
          '<p>Le Client peut consulter, sur les Supports Digitaux concernés, les conditions d’obtention et, le cas échéant, la date à laquelle l’avantage a été reversé.</p>',

          '<h3>3. Période de validité</h3>',
          '<p>Chaque Offre perso est valable, sauf indication contraire, pendant une semaine, du lundi au dimanche. Le Client dispose, en principe, de huit (8) ou neuf (9) Offres perso simultanément proposées chaque semaine. Ces offres sont renouvelées chaque lundi, selon les modalités du programme.</p>',
          '<p>La période de validité, le nombre d’utilisations autorisées, les éventuelles limites de quantité ainsi que toute autre condition particulière sont indiquées sur chaque Offre perso.</p>',
          '<p>Lorsqu’une Offre perso est soumise à une limite de disponibilité et que cette limite est atteinte avant la fin de sa période de validité, l’Offre perso peut ne plus être disponible. Lorsqu’une Offre perso est remplacée, les conditions applicables à la nouvelle offre sont celles indiquées sur celle-ci.</p>',

          '<h3>4. Conditions d’utilisation de « Vos offres perso »</h3>',
          '<p>Chaque Offre perso doit être utilisée conformément aux conditions qui lui sont propres et qui sont indiquées sur l’Offre perso ou sur les Supports Digitaux.</p>',
          '<p>Ces conditions peuvent notamment préciser :</p>',
          '<ul><li>la quantité minimale ou maximale de produits à acheter pour bénéficier de l’avantage ;</li><li>les produits, références, marques ou catégories de produits concernés ;</li><li>la période pendant laquelle les achats doivent être effectués ;</li><li>les éventuelles conditions de cumul avec d’autres promotions ou avantages ;</li><li>les éventuelles restrictions liées à l’utilisation de l’offre en magasin ou sur le Drive ;</li><li>les éventuelles limites d’utilisation par Client.</li></ul>',
          '<p>Le Client est invité à prendre connaissance de l’ensemble des conditions applicables à chaque Offre perso avant de procéder à son utilisation.</p>',
          '<p>Pour bénéficier d’une Offre perso en magasin, le Client doit présenter ou utiliser sa Carte de Fidélité au moment du passage en caisse, conformément aux modalités indiquées sur l’Offre perso.</p>',

          '<h3>5. Disponibilité des produits</h3>',
          '<p>« Vos offres perso » portent sur des produits susceptibles d’être temporairement indisponibles dans certains magasins ou sur certains canaux de vente. La disponibilité des produits peut varier selon les magasins, les stocks disponibles et les modalités de vente applicables.</p>',

          '<h3>6. Caractère personnel de « Vos offres perso »</h3>',
          '<p>Les Offres perso sont attribuées individuellement au Client et sont liées à sa Carte de Fidélité.</p>',
          '<p>Elles ne peuvent être cédées, vendues, échangées ou transférées à un autre Client, sauf indication contraire expresse.</p>',
          '<p>Elles ne peuvent donner lieu à un paiement en espèces, à un remboursement ou à une conversion en un autre avantage, sauf disposition contraire expressément prévue pour l’Offre perso concernée.</p>',
          '<p>Le Client ne peut utiliser une Offre perso que dans les conditions prévues par celle-ci.</p>',

          '<h3>7. Utilisation frauduleuse ou irrégulière</h3>',
          '<p>Intermarché se réserve le droit de refuser l’utilisation d’une Offre perso lorsqu’il est établi que celle-ci a été obtenue ou utilisée frauduleusement, notamment en cas de falsification, de modification non autorisée, de détournement du dispositif ou de non-respect des présentes conditions.</p>',
          '<p>En cas d’anomalie technique ou de dysfonctionnement affectant l’affichage ou l’utilisation d’une Offre perso, le Client est invité à contacter le service client selon les modalités indiquées sur les Supports Digitaux.</p>',
          '<p>Une Offre perso ne peut être annulée ou refusée du seul fait d’une erreur matérielle imputable à Intermarché lorsque le Client remplit par ailleurs les conditions d’utilisation de cette offre, sous réserve des dispositions légales applicables.</p>',
        ],
      },
      legalMention: {
        color: '#1D1D1D',
        fontFamily: 'var(--font-family)',
        label:
          'POUR VOTRE SANTÉ, ÉVITEZ DE MANGER TROP GRAS, TROP SUCRÉ, TROP SALÉ.',
      },
    },
    couponDetails: {
      variant: Variants.VARIANT_1,
      meta: {
        title: 'Offer details - Coupons App',
        keywords: 'offer details, coupon information, expiration date, terms',
        description:
          'Get all the details about your selected offer in the Coupons App. View the description, expiration date, participating stores, eligible products, and terms & conditions to make the most of your discounts.',
      },
      background: '#F8F7F5',
    },
  },
  components: {
    coupons: {
      variant: Variants.VARIANT_1,
      background: 'white',
      card: {
        border: 'none',
        minWidth: '288px',
        maxWidth: '398px',
        borderRadius: '20px',
        background: 'transparent',
        filter: 'drop-shadow(0 4px 4px rgba(156, 163, 173, 0.2))',
      },
      borders: {
        left: 'assets/images/draco/left-bar.svg',
        right: 'assets/images/draco/right-bar.svg',
      },
      info: {
        iconUrl: 'assets/images/draco/info-icon.svg',
        ariaLabel: 'Conditions de l’offre',
      },
      loadTag: {
        color: '#11713e',
        label: 'Offre activée',
        background: '#e3f5ec',
        iconUrl: 'assets/images/draco/check-bold.svg',
      },
      sticker: {
        color: '#FFFFFF',
        background: '#1e8900',
        template:
          '<span style="width: 100%; font-size: 18px; font-weight: 700; line-height: 24px;">{variable}</span><span style="width: 100%; font-size: 9px; font-weight: 700; line-height: 10px; text-transform: uppercase;">EN AVANTAGE CARTE</span>',
      },
      couponLabel: {
        [CouponOfferType.BASKET]: 'sur tout le magasin',
        [CouponOfferType.PRODUCT]:
          'sur la marque <span style="font-size: 16px;font-weight: 700;line-height: 18px;display: block;">{variable}</span>',
        [CouponOfferType.CATEGORY]:
          'sur le rayon <span style="font-size: 16px;font-weight: 700;line-height: 18px;display: block;">{variable}</span>',
      },
      counter: {
        text: {
          warning: '<span>Fin dans :</span><strong>{variable} jours</strong>',
          default:
            '<span>Fin dans :</span><strong style="color: #1D1D1D;">{variable} jours</strong>',
        },
        color: {
          warning: '#e55c00',
          default: '#737C8C',
        },
        icon: {
          warning: 'assets/images/draco/short-chrono.svg',
          default: 'assets/images/draco/long-chrono.svg',
        },
      },
      couponDescription: {
        [CouponOfferType.BASKET]: 'Dès&nbsp;<strong>{variable}</strong>',
        [CouponOfferType.PRODUCT]:
          "Dès&nbsp;<strong>{variable}</strong>&nbsp;d'achat en ligne ou en magasin",
        [CouponOfferType.CATEGORY]:
          "Dès&nbsp;<strong>{variable}</strong>&nbsp;d'achat en ligne ou en magasin <br> Toutes marques, dont marques Intermarché",
      },
      buttons: {
        load: {
          label: 'Activer',
          color: '#FFFFFF',
          background: '#1D1D1D',
          border: '1px solid #1D1D1D',
        },
        scan: {
          color: '#1d1d1d',
          background: 'white',
          label: "Vérifier l'éligibilité",
          border: '1px solid #1d1d1d',
        },
      },
    },
    modals: {
      closeButton: {
        label: 'Fermer',
        textColor: 'white',
        borderRadius: '50px',
        backgroundColor: '#1D1D1D',
        fontFamily: 'var(--font-family)',
        ariaLabel: 'Fermer cette boîte de dialogue',
      },
      termsAndConditions: {
        background: '#FFFFFF',
        ariaLabel: 'Conditions de l’offre',
        title: {
          color: '#1D1D1D',
          label: 'Conditions de l’offre',
          fontFamily: 'var(--font-family)',
        },
        body: {
          color: '#1D1D1D',
          fontFamily: 'var(--font-family)',
        },
        closeButton: {
          label: 'Fermer',
          color: '#FFFFFF',
          border: 'none',
          borderRadius: '50px',
          backgroundColor: '#1D1D1D',
          fontFamily: 'var(--font-family)',
        },
        drawer: {
          closeButton: {
            imageUrl: 'assets/images/draco/close-icon.svg',
            alternativeText: 'Fermer cette boîte de dialogue',
          },
          illustration: {
            pentagonUrl: 'assets/images/draco/how-to-play-pentagon.svg',
            illustrationUrl: 'assets/images/draco/how-to-play-voucher.webp',
            illustrationAlt: '',
          },
        },
      },
      genericError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          label: 'Activation impossible',
          fontFamily: 'var(--font-family)',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Une erreur est survenue et l’offre n’a pas pu être activée. Veuillez vérifier votre connexion et réessayer.',
        },
      },
      timeoutError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          label: 'Délai dépassé',
          fontFamily: 'var(--font-family)',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'L’activation de l’offre a pris trop de temps. Veuillez vérifier votre connexion et réessayer.',
        },
      },
      productCheck: {
        backgroundColor: '#FFFFFF',
        fontFamily: 'var(--font-family)',
        ariaLabel: 'verification barcode modal',
        tabs: [
          // First tab = default view: manual barcode entry (EAI-2217), the
          // scanner stays available as the second tab.
          {
            label: 'CODE-BARRES',
            successMessage: 'Succès',
            submitButtonLabel: 'Vérifier',
            type: ProductCheckTabType.MANUAL,
            checkMode: ScanCheckMode.SERVER,
            title: 'Saisissez le code-barres du produit',
            inputPlaceholder: 'Code-barres du produit',
            checkingMessage: 'Vérification en cours…',
            errorMessage: 'Non éligible pour cette offre',
            failureMessage: 'Une erreur est survenue, veuillez réessayer',
          },
          {
            label: 'SCANNER',
            successMessage: 'Succès',
            type: ProductCheckTabType.SCAN,
            checkMode: ScanCheckMode.SERVER,
            title: 'Scannez votre code barre !',
            checkingMessage: 'Vérification en cours…',
            startButtonLabel: 'Démarrer le scanner',
            retryPermissionButtonLabel: 'Réessayer l’accès à la caméra',
            restartButtonLabel: 'Redémarrer le scanner',
            errorMessage: 'Non éligible pour cette offre',
            failureMessage: 'Une erreur est survenue, veuillez réessayer',
            errorWhenCameraPermissionDenied:
              'Veuillez autoriser l’accès à la caméra pour utiliser le scanner.',
            errorWhenCameraNotFound: 'Caméra non disponible',
            errorWhenCameraBusy:
              'La caméra est utilisée par une autre application. Fermez-la, puis réessayez.',
            previewLabel: 'Aperçu du scanner de code-barres',
            readers: [BARCODE_FORMAT.EAN_8, BARCODE_FORMAT.EAN_13],
          },
        ],
        tabConfig: {
          activeColor: 'white',
          inactiveColor: 'black',
          inactiveBackground: 'white',
          fontFamily: 'var(--font-family)',
          inactiveBorderBottom: '2px solid #e6e6e6',
          activeBackground: 'var(--challenge-primary-color)',
          activeBorderBottom: '2px solid var(--challenge-primary-color)',
        },
      },
      savingsDetails: {
        background: '#FFFFFF',
        loadingLabel: 'Chargement…',
        title: {
          color: '#1D1D1D',
          label: 'Détails de mes économies',
          fontFamily: 'var(--font-family)',
        },
        closeButton: {
          imageUrl: 'assets/images/draco/close-icon.svg',
          alternativeText: 'Fermer cette boîte de dialogue',
        },
        tabs: {
          config: {
            fontFamily: 'var(--font-family)',
            border: {
              active: '2px solid #010101',
              default: '2px solid #E2E6EE',
            },
            background: {
              active: '#010101',
              default: '#FFFFFF',
            },
            color: {
              active: '#FFFFFF',
              default: '#1D1D1D',
            },
          },
          week: { label: 'Semaine en cours' },
          year: { label: 'Année en cours' },
        },
        total: {
          background: '#E6F4E0',
          iconUrl: 'assets/images/draco/savings-total-icon.webp',
          iconAlt: '',
          amount: {
            color: '#1D1D1D',
            fontFamily: 'var(--font-family)',
          },
          label: {
            color: '#1D1D1D',
            label: 'Total de ma cagnotte',
            fontFamily: 'var(--font-family)',
          },
        },
        list: {
          background: '#FFFFFF',
          borderColor: '#E2E6EE',
          dividerColor: '#E2E6EE',
          iconBackground: '#F0F2F6',
          title: {
            color: '#1D1D1D',
            fontFamily: 'var(--font-family)',
          },
          subtitle: {
            color: '#4A5160',
            fontFamily: 'var(--font-family)',
            label: 'Utilisé le {variable}',
            dateFormat: 'dd/MM/yyyy',
          },
          amount: {
            color: '#4A5160',
            fontFamily: 'var(--font-family)',
          },
        },
        campaignList: {
          iconUrl: 'assets/images/draco/savings-total-icon.webp',
          title: {
            color: '#1D1D1D',
            label: 'Du {startDate} au {endDate}',
            fontFamily: 'var(--font-family)',
            startDateFormat: { sameMonth: 'd', otherMonth: 'd MMM' },
            endDateFormat: 'd MMMM',
          },
          current: {
            color: '#1855B6',
            label: 'En cours de traitement',
            fontFamily: 'var(--font-family)',
          },
          completed: {
            color: '#4A5160',
            label: 'Cagnotté le {variable}',
            fontFamily: 'var(--font-family)',
            dateFormat: 'dd/MM/yyyy',
          },
          unavailable: {
            placeholder: '—',
            label: 'Montant indisponible',
          },
        },
        emptyState: {
          pentagonUrl: 'assets/images/draco/savings-empty-pentagon.svg',
          illustrationUrl: 'assets/images/draco/savings-empty-basket.webp',
          illustrationAlt: '',
          title: {
            color: '#1D1D1D',
            label: 'Vous n’avez effectué aucun achat pour le moment',
            fontFamily: 'var(--font-family)',
          },
          body: {
            color: '#1D1D1D',
            label:
              'Pensez à présenter votre carte de fidélité lors de vos achats pour suivre vos économies.',
            fontFamily: 'var(--font-family)',
          },
        },
      },
    },
  },
};
